import React from 'react'
import {Text} from './HomePageElements'

const HomePage = () => {
    return (
        <>
            <Text>Strona została stworzona w ramach projektu realizowanego przez SKN Bioinformatyków.</Text>
        </>
    )
}

export default HomePage
